export default __webpack_public_path__ + "static/comp4-0d1e48d6d1dd35b9b2aad187de4dbd9c.png";